module.exports = " <div class=accordion v-bind:class=\"{'accordion--opened':opened}\"> <p class=accordion__title v-on:click=toggle>{{title}}</p> <div class=accordion__content v-if=opened> <div class=filter-list> <div class=checkbox v-for=\"item in items\"> <input type=checkbox :id=\"'filter-'+item.Id\" v-model=item.checked @change=selected><label :for=\"'filter-'+item.Id\" class=\"filter-list__label tick-green left\">{{item.Name}}</label> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/views/filter/FilterCategoriesAccordion.vue
// module id = 188
// module chunks = 0